export default __webpack_public_path__ + "static/media/kc.70ac45bb.png";